import React from 'react'
import { CanvasWorkspace } from './CanvasWorkspace'
import type { Artifact } from '../types'

interface ArtifactSidebarProps {
  isOpen: boolean
  onClose: () => void
  title: string
  htmlContent: string
  artifact?: Artifact | null
  onSaveArtifact?: (updated: Artifact) => void
  onRewriteSelection?: (selectedText: string, instruction: string) => Promise<string | void>
}

export const ArtifactSidebar: React.FC<ArtifactSidebarProps> = ({
  isOpen,
  onClose,
  title,
  htmlContent,
  artifact,
  onSaveArtifact,
  onRewriteSelection,
}) => {
  const currentArtifact: Artifact = artifact ?? {
    id: `art_${title.toLowerCase().replace(/\s+/g, '_')}`,
    title: title || 'Sales Deliverable',
    content: htmlContent || '',
    version: 1,
    history: [
      {
        version: 1,
        title: title || 'Sales Deliverable',
        content: htmlContent || '',
        author: 'ai',
        timestamp: new Date(),
      },
    ],
    createdAt: new Date(),
    updatedAt: new Date(),
  }

  return (
    <CanvasWorkspace
      isOpen={isOpen}
      onClose={onClose}
      artifact={currentArtifact}
      onSaveArtifact={onSaveArtifact}
      onRewriteSelection={onRewriteSelection}
    />
  )
}
